import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private url = (window.location.hostname == 'localhost') ? 'http://localhost:4201' : 'https://api.bookinglab.co.uk';
  private token = "d9a8ae8f05419f520d443bacec2a862163821d05ce1e31678e873e70106e16be";

  constructor(private http: HttpClient) { }


  async payment(companyId, orderId, amount, bookingId, currentPage) {

    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}` };
    const body = {
      'host': environment.environmentURL,
      'company_id': `${companyId}`,
      'order_id': `${orderId}`,
      'amount': `${amount}`,
      'booking_id': `${bookingId}`,
      'current_page': `${currentPage}`,
    };
    return await this.http.post(`${this.url}/payment/elavon`, body,  { headers }).toPromise();
  }
}
